export const jsExtensions = [
    '.mtsx',
    '.ctsx',
    '.tsx',
    '.mts',
    '.cts',
    '.ts',
    '.mtsx',
    '.ctsx',
    '.tsx',
    '.mts',
    '.cts',
    '.ts',
];
